import { render, staticRenderFns } from "./EducationDetailsSidebar.vue?vue&type=template&id=8d696faa&scoped=true"
import script from "./EducationDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./EducationDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./EducationDetailsSidebar.vue?vue&type=style&index=0&id=8d696faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d696faa",
  null
  
)

export default component.exports